import { render, staticRenderFns } from "./ImageSelectTemplate.vue?vue&type=template&id=0bd7f7a5&scoped=true"
import script from "./ImageSelectTemplate.vue?vue&type=script&lang=js"
export * from "./ImageSelectTemplate.vue?vue&type=script&lang=js"
import style0 from "./ImageSelectTemplate.vue?vue&type=style&index=0&id=0bd7f7a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd7f7a5",
  null
  
)

export default component.exports